export default __webpack_public_path__ + "static/media/vegas-pro-logo.ee46ad28.svg";